import jwt_decode from 'jwt-decode';
// import UsuarioContext from "../models/UsuarioContext";

const tokenName = "KNFY_TOKEN";

export const setToken = (jwtToken: string) => {
    localStorage.setItem(tokenName, jwtToken)
}

export const getToken = () => {
    return localStorage.getItem(tokenName);
}

export const justLogout = () => {
    localStorage.removeItem(tokenName);
}

export const logout = () => {
    localStorage.removeItem(tokenName);
    window.location.href = "/login";
}

export const checkIsValidAuthenticated = (): boolean => {
    let tokenDecoded: any = decodedToken()
    try {
        if (Date.now() >= tokenDecoded.exp * 1000) {
            logout();
            return false;
        }
        return true;
    } catch (e) {
        logout()
        return false;
    }
}

export const decodedToken = (): any => {
    let token = localStorage.getItem(tokenName);
    if(token != null) {
        return jwt_decode(token);
    }
}

// export const getUserRolesOfToken = (): string[] => {
//     const user: UsuarioContext = getUserByToken();
//     if(user.id === undefined || user.id === null) {
//         return [];
//     }
//     if(user.roles === undefined) {
//         return [];
//     }
//     return user.roles;
// }

export const getUserByToken = () => {
    let decodedTokenValue = decodedToken()
    let userDecoded = decodedTokenValue.usuario
    let user = {
        "id": userDecoded.id,
        "nome": userDecoded.nome,
        "email": userDecoded.email,
        "roles": userDecoded.roles,
    }
    return user;
}
